if (!customElements.get('size-chart')) {
    class SizeChart extends HTMLElement {
        constructor() {
            super();

            this.attachOpener();
            this.attachUnitsToggle();
        }

        /**
         * Opens the drawer.
         */
        attachOpener() {
            const drawer = document.querySelector('.js-size-chart-drawer');
            if (drawer) drawer.remove();

            document.body.appendChild(drawer);

            const showSizeChartBtn = this.querySelector('.js-show-size-chart');
            if (showSizeChartBtn) {
                showSizeChartBtn.addEventListener('click', () => {
                    document.querySelector('.js-size-chart-drawer').open(showSizeChartBtn);
                });
            }
        }

        /**
         * Toggle Units between "cm" and "in".
         */
        convertUnits(newUnit) {
            const sizeCharts = document.querySelectorAll('#sizechart');
            const currentUnitLabel = document.getElementById('currentUnitSizeChart');
            let originalValues = {};
            const isCM = newUnit === "cm";

            if ((currentUnitLabel.innerText.includes("CM") && newUnit === "cm") || (currentUnitLabel.innerText.includes("INCH") && newUnit === "in")) {
                return;
            }

            sizeCharts.forEach(function(sizeChart) {
                sizeChart.querySelectorAll('tbody tr').forEach(function(row) {
                    row.querySelectorAll('td').forEach(function(element, index) {
                        if (index >= 2) {
                            const value = element.textContent;
                            if (!(value in originalValues)) {
                                originalValues[value] = value;
                            }
                            const range = value.split('-');
                            const convertedRange = range.map(function(num) {
                                return isCM 
                                    ? Math.round(parseFloat(num) * 2.54) 
                                    : Math.round(parseFloat(num) / 2.54);
                            });
                            element.textContent = convertedRange.join('-');
                        }
                    });
                });
            });

            currentUnitLabel.innerText = `Current is ${newUnit === "cm" ? "CM" : "INCH"}`;

        }

        /**
         * Adds toggle behavior.
         */
        attachUnitsToggle() {
            document.querySelectorAll('.size-chart-toggle').forEach(toggle => {
                toggle.addEventListener('click', e => {
                    const btn = e.target.closest('.size-chart-toggle__option');
                    if (!btn) return;

                    toggle
                        .querySelectorAll('.size-chart-toggle__option')
                        .forEach(b => b.classList.remove('is-active'));

                    btn.classList.add('is-active');

                    const unit = btn.dataset.unit;
                    this.convertUnits(unit);

                });
            });
        }
    }

    customElements.define('size-chart', SizeChart);
}
